import React, { useState, useCallback, useEffect } from "react";

import {
    Box,
    Paper,
    Divider,
    TextField,
    Grid,
    Typography,
    Switch,
    FormControlLabel,
    styled,
    Card,
    Chip
} from '@mui/material';

import { useNavigate, useParams } from "react-router-dom";
// import { useFormik } from 'formik';
import CommonBreadcumbs from "../common/CommonBreadcumbs"
import CommonSectionHeader from "../common/CommonSectionHeader";
import CommonRestricted from '../common/CommonRestricted';
import CommonJsonViewer from "../common/CommonJsonViewer";

import { useAuditTrails, auditTrailTypes, targetTypes } from '../../hooks/api/useAuditTrails';
import { useSystemPrompt } from "../../hooks/useSystemPrompt";
import { useSystemRoutes, routeTypes } from '../../hooks/useSystemRoutes';
import { useSystemHead, headTitles } from '../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../hooks/usePermissions';

import { useAppContextFeatures } from "../../context/AppContext";

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));

export const StyledIcon = styled(Box)({
    width: 100,
    height: 100,
    opacity: 0.1,
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
});

const StyledLabel = styled(Typography)(({ theme }) => ({
    fontSize: '0.9rem',
    fontWeight: 800
}))

const StyledContent = styled(Typography)(({ theme }) => ({
    fontSize: '0.9rem'
}))

const StyledDivider = styled(Divider)(({ theme }) => ({
    mt: 1,
    mb: 0,
    borderStyle: 'dashed'
}))

const StyledDivider2 = styled(Divider)(({ theme }) => ({
    mt: 0,
    mb: 1,
    borderStyle: 'dashed'
}))

export default function ViewAuditTrail({
    routeType
}) {

    const { id } = useParams();

    const { promptMessage } = useSystemPrompt();
    const { get } = useAuditTrails({ auditTrailType: auditTrailTypes.auditTrail, targetType: targetTypes.auditTrail });
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.audit.id, scopeTypes.audit.auditTrail.id)

    const navigate = useNavigate();
    const { getRoute } = useSystemRoutes(routeType);
    const { getHtmlHead } = useSystemHead(routeType)

    const { setSystemLoading } = useAppContextFeatures()

    const [data, setData] = useState()

    const loadData = useCallback(async (id) => {

        setSystemLoading(true);

        try {

            const { data } = await get({ id })
            // console.log('response?.data?.items', response?.data)
            setData(data)

        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

        setSystemLoading(false)

    }, [id])

    useEffect(() => {

        loadData(id);

    }, [])

    const RenderInfo = ({ item }) => {

        if (!data) return <></>

        return (
            <StyledCard sx={{ mt: 0 }}>
                <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={`Information`}
                            subTitle={`Trail details for the audit performed`}
                        />

                    </Grid>

                    <Grid item xs={12}>
                        <StyledDivider />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12} sx={{ mt: 2 }}>
                        <Grid container spacing={2}>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>Target</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {item?.target}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>Module</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {item?.module}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>Trail Ref</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {item?.trail_ref}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>Refer ID</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {item?.refer_id}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>Type</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {item?.type}
                                </StyledContent>
                            </Grid>

                            <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                <StyledLabel>Description</StyledLabel>
                            </Grid>
                            <Grid item xs={12} sm={12} md={8} textAlign={"left"}>
                                <StyledContent>
                                    {item?.description}
                                </StyledContent>
                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>
            </StyledCard>
        )
    }

    const RenderTagInfo = ({ tagInfo }) => {

        if (!data) return <></>

        return (
            <StyledCard>
                <Grid container spacing={1}>

                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>
                        <CommonSectionHeader
                            title={`Tags`}
                            subTitle={`List of tags info`}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <StyledDivider />
                    </Grid>

                    <Grid item xs={12} sm={12} md={12}>
                        {
                            tagInfo.map((i) => {
                                return (
                                    <Grid container spacing={2} key={i.id} >
                                        <Grid item xs={12} sm={12} md={5} textAlign={"left"}>
                                            <Chip
                                                label={`Tag: ${i.tag_label}`}
                                                color="primary"
                                                sx={{
                                                    fontSize: "13px",
                                                    fontWeight: 800
                                                }}
                                                key={i.id}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={7} textAlign={"left"}>
                                            <></>
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={3} textAlign={"left"}>
                                            <StyledLabel>Description</StyledLabel>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={9} textAlign={"left"}>
                                            <StyledContent>
                                                {i?.description}
                                            </StyledContent>
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={12} textAlign={"left"}
                                            sx={{
                                                mb: 2
                                            }}
                                        >
                                            <StyledDivider2 />
                                        </Grid>

                                    </Grid>
                                )
                            })
                        }
                    </Grid>
                </Grid>
            </StyledCard>
        )
    }

    const RenderForm = () => {

        if (!data) return <></>

        const { audit_trail: item, tags: tagInfo } = data

        return (
            <Grid container spacing={1} textAlign={"left"}>
                <Grid item md={7}>
                    <RenderInfo
                        item={item}
                    />
                </Grid>
                <Grid item md={5}>
                    <RenderTagInfo
                        tagInfo={tagInfo}
                    />
                    <></>
                </Grid>
            </Grid>
        )
    }

    const getBreadcumbActionMenus = () => {

        let props = []

        // if (isPermissionAllow({ functionType: functionTypes.pageUpdate.id })) {
        //     props.push({
        //         displayText: "Edit Item",
        //         href: getRoute(`product/item/update/${id}`),
        //     })
        // }

        return props

    }

    return (
        <Box>

            {
                getHtmlHead({ routeType, title: headTitles.viewAudit })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={`View Audit Trail`}
                actionMenus={
                    getBreadcumbActionMenus()
                }
                breadcrumbs={[
                    {
                        displayText: "Audit Trails",
                        props: {
                            href: getRoute("settings/auditTrails")
                        }
                    },
                    {
                        displayText: `View Audit Trail`,
                        props: {
                            color: 'secondary.main'
                        }
                    },
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageNew.id }) ?
                    RenderForm()
                    :
                    <CommonRestricted />
            }

        </Box>
    )
}